// extracted by mini-css-extract-plugin
export default {"flows-list":"FlowsList_flows-list__eYLwG","flows-list-home-page":"FlowsList_flows-list-home-page__F5Udv","flow-skeleton":"FlowsList_flow-skeleton__JFUyP"};